import {stringToAttributeId} from '../components/spc/util/spcUtils';

export function getProductData(attributeKey, productData) {
	if (!productData) return null;
	return productData.reduce(
		(feat, component) => {
			const f = component.features.find(
				feature => feature.featureId === stringToAttributeId(attributeKey).localId
			);
			if (f) {
				return f;
			} else {
				return feat;
			}
		},
		null
	);
}
